import React, { createContext } from "react";
import { Row } from "react-bootstrap";
import { useForm } from "react-hook-form";

export const Context = createContext({});

const Form = ({ defaultValues, children, onSubmit }) => {
  const {
    handleSubmit,
    setValue,
    getValues,
    register,
    control,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues,
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Row>
        {/* {Array.isArray(children)
          ? children.map((child, index) => {
              return child.props.name
                ? React.createElement(child.type, {
                    ...{
                      ...child.props,
                      register,
                      errors: errors,
                      control,
                      values: defaultValues,
                      setValue: setValue,
                      key: child.props.name + "input___" + index,
                    },
                  })
                : child;
            })
          : children} */}
        <Context.Provider
          value={{
            register,
            errors: errors,
            control,
            values: defaultValues,
            setValue,
            getValues,
            watch,
          }}
        >
          {children}
        </Context.Provider>
      </Row>
    </form>
  );
};
export default Form;
